import type { RouteDef } from '../../../dashboardDef.type';
import getEnvironment from './getEnvironment';

/**
 * Filters out routes flagged `isDev: true` when NOT running in a dev/preview
 * environment (localhost / preview hostname). Dev-only pages such as the Colib
 * UI showcase carry `isDev: true` so they never appear in the sidebar for real
 * clients on production. Mirrors the shape of getRoutesWithFeatureFlag.
 */
const getRoutesWithEnvironment = (routesDef: RouteDef[]): RouteDef[] => {
  const { isDev } = getEnvironment();
  const isVisible = (route?: { isDev?: boolean }) => !route?.isDev || isDev;

  return routesDef.reduce<RouteDef[]>((acc, route) => {
    if (!isVisible(route)) return acc;

    const childRoutes = route.routes?.filter((subRoute) => {
      subRoute.routes = subRoute.routes?.filter(isVisible);
      return isVisible(subRoute);
    });

    acc.push(childRoutes ? { ...route, routes: childRoutes } : route);
    return acc;
  }, []);
};

export default getRoutesWithEnvironment;
